import React from 'react';
import { BrowserRouter, Routes } from 'react-router-dom';
import { merchantRoutes } from './pages/merchant/routes';
import { adminRoutes } from './pages/admin/routes';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {merchantRoutes}
        {adminRoutes}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
